import { render, staticRenderFns } from "./AddFaculty.vue?vue&type=template&id=4ffd4044&scoped=true"
import script from "./AddFaculty.vue?vue&type=script&lang=js"
export * from "./AddFaculty.vue?vue&type=script&lang=js"
import style0 from "./AddFaculty.vue?vue&type=style&index=0&id=4ffd4044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd4044",
  null
  
)

export default component.exports